import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import UserSettingsAvatarHeader from './UserSettingsAvatarHeader';
import Button from 'components/Button';
import InfoBar from 'components/InfoBar';

import * as actions from 'actions';
import { getUserPasswordUpdate, getInfoState } from 'selectors';

import './style.scss';
import validate from './validate';

class UserSettings extends Component {

  constructor() {
    super();

    this.handleInfoBarClose = this.handleInfoBarClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillUnmount() {
    this.props.onWillUnmount();
  }

  renderField({ input, label, type, meta: { touched, error } }) {
    return (
      <div className="form-field-wrapper">
        <input {...input} className={(touched && error) ? 'is-invalid-input' : ''} placeholder={label} type={type} />
        {touched && error && <span className="form-error is-visible">{error}</span>}
      </div>
    );
  }

  handleInfoBarClose() {
    if(this.props.onInfoBarClose) {
      this.props.onInfoBarClose();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.invalid || this.props.isPasswordUpdating) return;
    this.props.handleSubmit();
  }

  render() {
    return (
      <section className="UserSettings content-wrapper has-background-medium">
        {this.props.isSuccessInfoBarVisible && <InfoBar isStatic onClose={this.handleInfoBarClose} type="primary" message={this.props.successInfoBarMessage} />}

        <div className="wrapper-small is-padded-top">
          <h1>{__('members.settings.title')}</h1>

          <div className="user-form">
            <UserSettingsAvatarHeader />

            <div className="user-change-password">
              <form onSubmit={this.handleSubmit}>
                <label>{__('members.settings.password.label')}</label>

                <Field name="oldPassword" label={__('members.settings.password.oldPlaceholder')} component={this.renderField} type="password"/>
                <Field name="newPassword" label={__('members.settings.password.newPlaceholder')} component={this.renderField} type="password"/>
                <Field name="newPasswordRepeat" label={__('members.settings.password.newConfirmPlaceholder')} component={this.renderField} type="password"/>

                {!!this.props.serverPasswordError &&
                <div className="form-wrapper-error-be alert callout">
                  <p>{this.props.serverPasswordError}</p>
                </div>}

                <div className="form-field-wrapper">
                  <Button
                    isYellow
                    iconType="preloader-dark"
                    hasIcon={this.props.isPasswordUpdating}
                    isDisabled={this.props.invalid || this.props.isPasswordUpdating}
                    onClick={this.handleSubmit}
                  >
                    {__('members.settings.password.button')}
                  </Button>
                  <input type="submit" hidden disabled={this.props.invalid || this.props.isPasswordUpdating} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

UserSettings.propTypes = {
  isSuccessInfoBarVisible: PropTypes.bool,
  invalid: PropTypes.bool,
  successInfoBarMessage: PropTypes.string,
  onInfoBarClose: PropTypes.func,
  serverPasswordError: PropTypes.string,
  isPasswordUpdating: PropTypes.bool,
  handleSubmit: PropTypes.func,
  onWillUnmount: PropTypes.func
};

const mapStateToProps = state => {
  const successState = getInfoState(state, 'success');
  const isSuccessInfoBarVisible = successState.visible;
  const successInfoBarMessage = successState.message;

  return {
    isSuccessInfoBarVisible,
    successInfoBarMessage,
    ...getUserPasswordUpdate(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onWillUnmount: () => {
      dispatch(actions.userUpdateReset());
    },
    onInfoBarClose: () => {
      dispatch(actions.infoClose('success'));
    },
    onSubmit: passwordData => {
      const { oldPassword : existingPassword, newPassword : passWord } = passwordData;
      dispatch(actions.userUpdate({ existingPassword, passWord }, false, null, __('members.settings.password.successMessage')));
    }
  };
};

UserSettings = reduxForm({ //eslint-disable-line no-class-assign
  form: 'userSettings',
  validate
})(UserSettings);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSettings);



/** WEBPACK FOOTER **
 ** ./src/members/Main/UserSettings/index.js
 **/